import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import StepsCards from './StepsCards'
import { stateComponentComplete } from '../../../models'
import { sendDataLayer } from '../../../helpers'

const ContentFour = () => {
const location = useLocation()

const [render, setRender] = useState<stateComponentComplete>({ ready: false })
useEffect(() => {
    if (render.ready) sendDataLayer('onload-pager', location.pathname)
    setRender({ ready: true })
}, [location.pathname, render.ready])

const steps = [
    {
        icon: '/assets/one.webp',
        title: '',
        step: [
            {
            highlight: 'Abre el enlace ',
            text: 'que recibiste por correo, SMS o WhatsApp de Profuturo.',
            },
        ],
    },
    {
        icon: '/assets/two.webp',
        title: '',
        step: [
            {
            highlight: 'Crea una contraseña ',
            text: 'para acceder a tu suscripción.',
            },
        ],
    },
    {
        icon: '/assets/three.webp',
        title: '',
        step: [
            {
            highlight: 'Elige tus temas ',
            text: 'de interés y personaliza tu experiencia.',
            },
        ],
    },
    {
        icon: '/assets/four.webp',
        title: '',
        step: [
            {
            highlight: 'Disfruta tu cuenta ',
            text: 'Soy+ por 365 días.',
            highlightClass: 'font-normal',
            textClass: 'font-bold',
            },
        ],
    },
]

    return (
        <main className="container_content_two">
        <section className="container_cards">
            <h1 className="title_container">¿Cómo activar tu suscripción?</h1>
            <div className="cards_grid_num">
            {steps.map((item, index) => (
                <StepsCards key={index} {...item} />
            ))}
            </div>
        </section>
        </main>
    )
}

export default ContentFour
